// Kontaktdaten in Bewerbungsantworten finden — eine Stelle für drei Leser:
// die KI-Schwärzung (der Prompt darf E-Mail und Telefon nie sehen), der
// Hinweis in der Ergebnisansicht, welche Angabe geschwärzt wurde, und der
// Wiederbewerber-Abgleich, der die Werte tatsächlich braucht.
// Wer die Schwellen hier ändert, ändert sie für alle drei.

const EMAIL_RE = /[\p{L}\p{N}._%+-]+@[\p{L}\p{N}.-]+\.[\p{L}]{2,}/giu;
// Ziffernfolgen mit Telefon-Interpunktion (+, Leerzeichen, -, /, (), .).
// Erst ab genug Ziffern eine Telefonnummer: die Schwelle von 9 lässt Daten
// (ttmmjjjj = 8) sowie Punktzahlen und Jahreszahlen unangetastet.
const PHONE_RE = /(?:\+|00)?\d[\d\s()./-]{5,}\d/g;

const isPhoneLike = (match) => {
    const digits = (match.match(/\d/g) || []).length;
    const hasIntlPrefix = /^\s*(?:\+|00)/.test(match);
    return digits >= 9 || (hasIntlPrefix && digits >= 7);
};

// Bringt jede Antwortform (Text, Liste, Matrixzeilen, Datei-Upload-Objekt) auf
// eine durchsuchbare Zeichenkette.
export const flattenAnswerText = (answer) => {
    if (answer == null) return '';
    if (typeof answer === 'string') return answer;
    if (typeof answer === 'number') return String(answer);
    if (Array.isArray(answer)) return answer.map(flattenAnswerText).join(' ');
    if (typeof answer === 'object') return Object.values(answer).map(flattenAnswerText).join(' ');
    return '';
};

// Entfernt persönliche Kontaktdaten aus Prompt-Text, damit sie Gemini nie
// erreichen — egal in welcher Frage sie stehen oder ob sie in einem Freitext
// wiederholt werden. HR sieht die echten Werte in den Ergebnissen weiterhin;
// nur der KI-Prompt wird gesäubert.
export const redactContactInfo = (text) => {
    if (typeof text !== 'string') return text;
    const withoutEmail = text.replace(EMAIL_RE, '[E-Mail entfernt]');
    return withoutEmail.replace(PHONE_RE, (match) => (isPhoneLike(match) ? '[Telefon entfernt]' : match));
};

// Gegenstück für die Oberfläche: meldet je Antwort, welche Kontaktangabe vor
// der KI-Bewertung entfernt wurde. Liefert nur Wahrheitswerte — die Rohwerte
// verlässt diese Funktion nie. EMAIL_RE/PHONE_RE tragen das g-Flag, lastIndex
// muss deshalb vor jedem Lauf zurückgesetzt werden.
export const detectRedactablePii = (text) => {
    if (typeof text !== 'string') return { email: false, phone: false };
    EMAIL_RE.lastIndex = 0;
    const email = EMAIL_RE.test(text);
    EMAIL_RE.lastIndex = 0;

    let phone = false;
    PHONE_RE.lastIndex = 0;
    let match;
    while ((match = PHONE_RE.exec(text)) !== null) {
        if (isPhoneLike(match[0])) {
            phone = true;
            break;
        }
    }
    PHONE_RE.lastIndex = 0;
    return { email, phone };
};

// Liefert die gefundenen Werte roh zurück. Einziger Aufrufer ist der
// Wiederbewerber-Abgleich, der zwei Bewerbungen vergleichen muss — er
// normalisiert sie anschließend selbst.
export const extractContactValues = (text) => {
    if (typeof text !== 'string') return { emails: [], phones: [] };
    EMAIL_RE.lastIndex = 0;
    const emails = text.match(EMAIL_RE) || [];
    EMAIL_RE.lastIndex = 0;
    PHONE_RE.lastIndex = 0;
    const phones = (text.match(PHONE_RE) || []).filter(isPhoneLike);
    PHONE_RE.lastIndex = 0;
    return { emails, phones };
};
